import * as angular from 'angular';
import * as d3 from 'd3';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ComponentDefinition, DateValue, } from '../../../models';
import { QualityPercentageEvolutionWidget } from './qualityPercentageEvolution.widget';
import { WidgetQualityResult } from '../../../models/Dashboards';
import { infoTextColor } from '../../../common/constants';

class QualityPercentageEvolutionController implements angular.IComponentController {
    data: DateValue[];
    id: string;
    options: any;
    series: any[];

    readonly boundData: { results: WidgetQualityResult, range: { beginDateTime: string, endDateTime: string } };
    readonly item: QualityPercentageEvolutionWidget;

    static $inject = ['$scope'];
    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.id = `id${this.item.guid}`;
        this.setData();
        this.setOptions();
        this.series = this.item ? [{
            name: this.item.name.replace(' evolution', ''),
            color: infoTextColor,
            identifier: 0,
            value: d => d.value,
            selector: () => 0,
            isVisible: true,
            isLineVisible: true,
            crosshairFormat: d => d3.format('2.2%')(d.value)
        }] : null;
        this._$scope.$watch(
            () => this.item.configuration.options.crosshairDate,
            (newValue) => this.options.crosshairDate = newValue
        );
        this._$scope.$watch(
            () => this.options.crosshairDate,
            (newValue) => this.item.configuration.options.crosshairDate = newValue
        );
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['boundData'] && changesObj['boundData'].currentValue) {
            this.setData();
            this.setOptions();
        }
    }

    private setData() {
        this.data = [];
        if (this.boundData && this.boundData.results) {
            const { results } = this.boundData;
            if (results.values) {
                this.data = results.values;
            } else if (results.percentagePerDate) {
                const data: DateValue[] = [];
                for (const key of Object.keys(results.percentagePerDate)) {
                    data.push({
                        timeStamp: key,
                        value: results.percentagePerDate[key]
                    });
                }
                this.data = data.sort((a, b) => a.timeStamp > b.timeStamp ? 1 : -1);
            }
        }
    }

    private setOptions() {
        this.options = {
            title: 'Evolution',
            'isLegendVisible': false,
            display: {
                yAxisFormat: '2.0%',
                yMin: 0,
                yMax: 1
            },
            isTitleVisible: false
        };
        if (this.options && this.options.display && this.boundData?.range?.beginDateTime && this.boundData?.range?.endDateTime) {
            this.options.display.xMin = moment(this.boundData.range.beginDateTime).toDate();
            this.options.display.xMax = moment(this.boundData.range.endDateTime).toDate();
        }
    }
}

export const wtQualityPercentageEvolution: ComponentDefinition = {
    componentId: 'wtQualityPercentageEvolution',
    controller: QualityPercentageEvolutionController,
    template: require('./qualityPercentageEvolution.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        boundData: '<'
    }
};